import { ErrorCodes } from '../enums';
import { DiceReceiverError } from '../errors';

export const NO_REALM_DATA_ERROR = new DiceReceiverError(
    'Failed to configure session',
    'Something went wrong! Please try again later...',
    ErrorCodes.NO_REALM_DATA,
    'NO_REALM_DATA'
);
